<template>
  <div class="ticket">
    <div class="ticket__items">
      <div
        v-for="(item, index) in listItems"
        :key="index"
        class="ticket__item"
        @click="handleActiveItem(index)"
        :class="{ active : item.isActive }"
      >
        <div class="ticket__item-icon">
          <img class="ticket__logo" :src="require(`@/assets/images/ticket/${item.icon}`)" />
        </div>
        <div class="ticket__item-title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
     listItems: [
       // {
       //   title: 'Scan QR Code',
       //   icon: 'qrcode-icon.png',
       //   isActive: false,
       //   function: 'handleScanQrCode',
       // },
       {
         title: 'Create Ticket(s)',
         icon: 'overview-icon.png',
         isActive: false,
         function: 'handleCreateTicket',
       },
       {
         title: 'Scan',
         icon: 'qrcode-icon.png',
         isActive: false,
         function: 'handleScanTicket',
       }
     ],
     phone: ''
    }
  },
  methods: {
    handleActiveItem(index) {
      let fncName = '';
      this.listItems.forEach((item, i) => {
        item.isActive = i === index;
        if (i===index) {
          fncName = item.function;
        }
      });
      eval("this."+fncName+"()");
    },
    // handleScanQrCode() {
    //   this.$router.push('/qrcode-input');
    // },
    handleCreateTicket() {
      this.$router.push('/lotto');
    },
    handleScanTicket() {
      this.$router.push('/ticket-input');
    }


  }
}
</script>
